import { useEffect } from "react";

/** Props Interface */
interface UseClickOutsideProps {
	ref: React.RefObject<HTMLDivElement | null>;
	handler: () => void;
	trigger?: "mousedown" | "mouseup";
}

export function useClickOutside({ ref, handler, trigger = "mousedown" }: UseClickOutsideProps) {
	/** Effects */
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (ref.current && !ref.current.contains(event.target as Node)) {
				handler();
			}
		};

		document.addEventListener(trigger, handleClickOutside);

		return () => {
			document.removeEventListener(trigger, handleClickOutside);
		};
	}, [ref, handler, trigger]);
}
